import { ArrowIcon, CalendarIcon } from "../../../assets/icons";

export const profileButtons = [
    {
        path: "table",
        text: "Табель",
        icon: <CalendarIcon width="24px" height="24px" />,
        type: "primary",
        requireCafe: true,
    },
    {
        path: "/admin",
        text: "Панель админа",
        icon: <ArrowIcon />,
        type: "secondary",
        onlyAdmin: true,
    },
    {
        path: "/superadmin",
        text: "Панель супер-админа",
        icon: <ArrowIcon />,
        type: "secondary",
        onlySuperAdmin: true,
    },
    {
        path: "faq",
        text: "FAQ",
        icon: <ArrowIcon />,
        type: "secondary",
        requireCafe: true,
    },
    {
        path: "motivation",
        text: "Моя мотивация",
        icon: <ArrowIcon />,
        type: "secondary"
    },
    {
        path: "/checklist",
        text: "Чек-Лист",
        icon: <ArrowIcon />,
        type: "secondary",
        requireCafe: true,
    },
    {
        path: "reports",
        text: "Отчеты по чек-листам",
        icon: <ArrowIcon />,
        type: "secondary"
    },
    {
        path: "/auth/updatePassword",
        text: "Сменить пароль",
        icon: <ArrowIcon />,
        type: "secondary"
    },
    {
        path: "/auth/twoFactor",
        text: "Двухфакторная аутентификация",
        icon: <ArrowIcon />,
        type: "secondary"
    },
];
